/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { ViewNcmPendenteLoteIntegracao } from '../../models/ViewNcmPendenteLoteIntegracao';


/**
 * Api services for the `ViewNcmPendenteLoteIntegracao` model.
 */

export class ViewNcmPendenteLoteIntegracaoApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewNcmPendenteLoteIntegracao`.
   */
  getModelName() {
    return "ViewNcmPendenteLoteIntegracao";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/ViewNcmPendenteLoteIntegracao.js